import { createAction } from "typesafe-actions";

const TYPE = "/panel/close";

export default createAction(TYPE)<void>();
